import axios from '@/api/requests/axios'

export default {
  getAll: (params) => axios.get(`/api/admin/v1/order-states`, { params }),
  getById: (id) => axios.get(`/api/admin/v1/order-states/${id}`),
  create: (contact) => axios.post(`/api/admin/v1/order-states`, contact),
  update: (contact) => axios.put(`/api/admin/v1/order-states`, contact),
  delete: (id) => axios.delete(`/api/admin/v1/order-states/${id}`)
}
